fx.ns("shared.renderers", class AlbumPhotoRenderer extends fx.Component{
    
	constructor(data)
	{
		super(data);

        this.photo = data;
        this.assets = fx.get("assets");
	}


	create()
	{
        this.image = new fx.components.Image({className : "image", data : this.photo.thumb});
		this.image.attr("data-class", "Photo");
		this.image.attr("data-id", this.photo.id);
		this.image.attr("data-width", this.photo.width);
		this.image.attr("data-height", this.photo.height);
        this.addChild(this.image, {width: "100%", height: "100%"});
        
        this.readyIcon = new fx.components.Image({data: this.assets.readyIcon, className: "icon"});
        this.addChild(this.readyIcon, {top: 6, right: 6, height: 30, width: 30});
    }
    
    onReady()
	{
		this.on("click", this._onClick);
    }
    
    _onClick()
    {
        this.data.select();
        //fx.get('bookmodel').albums.trigger("albums-select-photo");
    }

	
	onDataUpdated(action)
	{
		if (action.impacts("selected") || action.type == "init")
		    this.toggleClass("selected", this.data.selected);
		
	}

});